const printPlugin = {
    install(Vue, options) {
      Vue.prototype.$print = function () {
        window.print();
      };
    }
  };
   
  export default printPlugin;


// WEBPACK FOOTER //
// ./src/utils/printPlugin.js